/**
 * use-deepl.ts — DeepL 集成 API 封装（全局单条 Key 管理）
 *
 * 对应后端 /api/v1/integrations/deepl/credential*（admin+）：整个 admin 系统一条全局 DeepL Key。
 * 明文 Key 仅提交、**永不回显**；GET 只回 configured + key_tail 掩码 + status。
 * 每方法 = 一次 apiRequest（自动带 JWT + X-Request-Id + 解 envelope 返 data，失败抛 AdminApiError）。
 * 请求/响应类型一律从 @novel-admin/shared 取（禁 web 侧重定义）。
 */

import type {
  DeeplCredentialResponse,
  DeeplCredentialTestResponse,
  UpsertDeeplCredentialRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const deeplApi = {
  /** 读全局凭证视图（掩码；未配置 → configured:false） */
  getCredential: () =>
    apiRequest<DeeplCredentialResponse>({
      method: 'GET',
      path: '/api/v1/integrations/deepl/credential',
    }),
  /** 录 / 换全局 DeepL Key（后端先 ping 验证再加密存；明文仅提交） */
  upsertKey: (body: UpsertDeeplCredentialRequest) =>
    apiRequest<DeeplCredentialResponse>({
      method: 'PUT',
      path: '/api/v1/integrations/deepl/credential',
      body,
    }),
  /** 移除全局凭证（软删，可再录入） */
  removeKey: () =>
    apiRequest<{ removed: true }>({
      method: 'DELETE',
      path: '/api/v1/integrations/deepl/credential',
    }),
  /** 测试连接（解密已存 Key + ping DeepL /v2/usage，更新 status） */
  testConnection: () =>
    apiRequest<DeeplCredentialTestResponse>({
      method: 'POST',
      path: '/api/v1/integrations/deepl/credential/test',
    }),
};
